import React, { useMemo, useEffect, createContext } from 'react'
import { useLocation } from 'react-router-dom'

import PropTypes from 'prop-types'

import { links } from 'components/Layout/Sidebar/Components/Menu/links'

import useLogger from 'hooks/useSentryLogger'

const RouteContext = createContext({
  currentPage: null,
})

export const RouteProvider = ({ children }) => {
  const location = useLocation()
  const logger = useLogger()

  const dataContext = useMemo(() => {
    const currentPage =
      links.find(page => location.pathname === page?.to?.pathname) ||
      links
        .map(link => link.children)
        .flat()
        .find(page => location.pathname === page?.to?.pathname)

    return { currentPage }
  }, [location.pathname])

  useEffect(() => {
    logger.info(
      'navigate_to',
      dataContext?.currentPage?.to?.pathname || 'unknown'
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataContext])

  return (
    <RouteContext.Provider value={dataContext}>
      {children}
    </RouteContext.Provider>
  )
}

RouteProvider.propTypes = {
  children: PropTypes.element.isRequired,
}

export default RouteContext
